"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var mergeDuplicateParamsInGroups = function mergeDuplicateParamsInGroups(transformedParamsToGroups) {
  return transformedParamsToGroups.map(function (g) {
    return (0, _extends2.default)({}, g, {
      parameters: Object.values(g.parameters.reduce(function (acc, p) {
        var prev = acc[p.code];

        if (prev) {
          prev.value = "".concat(prev.value, ", ").concat(p.value);
        } else {
          acc[p.code] = (0, _extends2.default)({}, p);
        }

        return acc;
      }, {}))
    });
  });
};

var _default = mergeDuplicateParamsInGroups;
exports.default = _default;